var exports = {
  "a": "Box__l50cBa",
};

module.exports = exports;
